"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var Divider = _styledComponents["default"].hr.withConfig({
  displayName: "Divider",
  componentId: "sc-gx5vd-0"
})(["border-radius:4px;height:8px;background-color:", ";border:none;flex-basis:100%;"], _baseReactComponents.theme.neutral100);

Divider.displayName = 'Divider';
var _default = Divider;
exports["default"] = _default;
//# sourceMappingURL=divider.js.map